module.exports = __webpack_public_path__ + "static/img/yangban.5f62a387.png";